import axios from "axios";

export const getPage = async (url) => {
    return axios.get(url);
}